// Reactjs library
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Action
import { getOperableFiscalPeriods } from '../../../Store/Actions/Pages/MainPage';
// Class & Component & Funtion
import { storageModel } from '../../../Models/CommonModel/StorageModel';
import { CookieAuthenModel } from '../../../Models/CommonModel/CookieAuthenModel';
import { RedirectWithComponent } from '../../../Constants/Utils';
// Resource + CSS
import { CompanySelected } from '../../../Constants/ConstantsValue';
import Router from "../../../Resources/Router.json";
import Screen from '../../../Resources/Screen.json';

function SelectCompany(props) {
    const cookieAuthenModel = new CookieAuthenModel();

    const companyModels = useSelector(state => state.MainPage.companiesModel);
    const companyData = props.companyData;

    const dispatch = useDispatch();

    // Event onClick when select company
    const handleCheckCompany = (value) => {
        let loginModel = cookieAuthenModel.GetWILoginModel();
        // Return login page if no have cookie of WorksI
        if (!loginModel) {
            RedirectWithComponent(Router.AccessPage);
            return;
        }

        let params = loginModel.CreateBaseRequestModel();

        const callBack = (res) => {
            if (!res)
                // Redirect error page if don't have response
                return RedirectWithComponent(Router.Error);

            // Save company selected to window.name
            let companySelected = companyModels.Companies.find(e => e.Id === value);
            storageModel.SetItem(CompanySelected, companySelected);

            // Call parant action
            props.seletedCompany(res);
        }
        // Call action get operable fiscal periods
        let action = getOperableFiscalPeriods(params, callBack);
        dispatch(action);
    }

    return (
        <>
            <div className='row justify-content-center'>
                <div className='col-left'></div>
                <div className="col-center border-list" style={{ maxWidth: "700px" }}>
                    <div className="card-header" style={{ fontWeight: "bold", textAlign: "left" }}>
                        {Screen.MainPage.TitleSelectCompany}
                    </div>
                    <ul className={companyData.length > 4 ? "addScroll list-group list-group-flush btn" : "list-group list-group-flush btn"}>
                        {companyData.map((item) => {
                            return <li className="list-group-item" key={item.Id} onClick={handleCheckCompany.bind(this, item.Id)} >
                                <div style={{ float: "left" }}>
                                    {item.DisplayName}
                                </div>
                                <div style={{ float: "right" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </div>
                            </li>
                        })}
                    </ul>
                </div>
                <div className='col-right'></div>
            </div>
        </>
    );
}

export default SelectCompany;